export default "__VITE_ASSET__B8_Qr3$G__"